<div ngbDropdown>
    <button type="button" class="dropdown-button" ngbDropdownToggle id="topbar-dropdown" tabindex="0">
        <!-- <a> -->
        <!-- <img alt="" [src]="language.flagPath" /> -->
        <!-- <span class="material-symbols-rounded" aria-label="Select language"> language </span> -->
        <!-- </a> -->

        <span class="material-symbols-rounded" aria-label="My account" style="font-size: 40px"> account_circle </span>

        <!-- <div class="circle">
            <div class="circle-inner pt-s05">
                <app-icon name="user" type="solid" />
            </div>
        </div> -->
        <!-- <p class="dropdown-name mt-s1">{{ firstName }}</p> -->
    </button>
    <div ngbDropdownMenu>
        <a class="dropdown-item" href="https://www.agreem.se/" target="_blank">
            <span class="material-symbols-rounded" aria-hidden="true"> open_in_new </span>
            {{ 'GENERAL.WEBSITE' | translate }}
        </a>
        <div class="dropdown-divider"></div>
        <a
            *ngFor="let language of languages"
            href="#"
            (click)="changeLanguage(language); $event.preventDefault()"
            class="dropdown-item"
        >
            <img alt="" [src]="language.flagPath" />
            <span class="ms-s1 me-s1">{{ language.name }}</span>
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item logout-text" href="javascript: void(0);" (click)="userProfile()">
            <span class="material-symbols-rounded" aria-hidden="true"> manage_accounts </span>
            {{ 'GENERAL.USERPROFILE' | translate }}
        </a>
        <a class="dropdown-item logout-text" href="javascript: void(0);" (click)="logout()">
            <span class="material-symbols-rounded" aria-hidden="true"> logout </span>
            {{ 'GENERAL.LOGOUT' | translate }}
        </a>
    </div>
</div>
